import { Box, Flex, GridItemProps, Skeleton, Text } from '@chakra-ui/react';
import isNil from 'lodash/isNil';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LectureSortDropdown } from '@/components/ui/shared/lecture/LectureSortDropdown/LectureSortDropdown';
import { TagFilters } from '@/components/ui/shared/tags/TagFilters/TagFilters';
import { useAnalytics } from '@/context/Analytics';
import { LectureSort } from '@/enums/LectureSort';

interface ILibrarySearchPanelProps extends GridItemProps {
  totalCount: number;
}

export const LibrarySearchPanel: FC<ILibrarySearchPanelProps> = ({ totalCount, ...rest }) => {
  const { t } = useTranslation();
  const analytics = useAnalytics();

  const formattedTotalCount = totalCount?.toLocaleString('en-US');

  return (
    <Flex direction="column" {...rest}>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        alignItems={{ base: 'flex-end', md: 'center' }}
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Text color="gray.500" textAlign="right" textStyle="plexBody">
          <Text as="span" fontSize="md" fontWeight="bold" fontFamily="heading">
            {formattedTotalCount}
          </Text>{' '}
          <Text as="span" fontSize="sm">
            {t('common.results')}
          </Text>
        </Text>

        <Box>
          <LectureSortDropdown
            w={{ base: 'full', md: 'auto' }}
            defaultSort={LectureSort.Relevance}
            trackAnalytics={(option) => analytics.track('library_sort', { sort_type: option })}
          />
        </Box>
      </Flex>
      <TagFilters display={{ base: 'none', sm: 'flex' }} />
    </Flex>
  );
};
